import React from 'react';
import { Link } from '@zola/zola-ui';
import OtherThingsToReview from './OtherThingsToReview';

function TipMenu() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>What To Include On Your Menu Card</h3>
          <div className="section">
            <p className="desc">
              What you include on your wedding menu cards is up to your preference and the style and
              tone of your wedding. Feel free to get creative and have fun with your wording, but
              you menu should include the following:
            </p>
          </div>
          <div className="section">
            <p className="head">1. Description of Courses (Or List Of Served Options)</p>
            <ul className="desc">
              <li>For Plated Meals: Outline the courses in the order they will be served.</li>
              <li>
                For Family-Style Meals: List the dishes and items that will be served to each table.
              </li>
              <li>
                For Buffet Meals: List the dishes and items that will be served at the buffet.
              </li>
            </ul>
          </div>
          <div className="section">
            <p className="head">2. Main Ingredients In Each Dish</p>
            <p className="desc">
              While it’s not required to list every ingredient used, it is customary to provide a
              short list of the main ingredients in each dish. Be sure to include foods that are
              common food allergies, such as nuts, shellfish, gluten, and dairy.
            </p>
          </div>
          <div className="section">
            <p className="head">3. A Welcome And Thank You (Optional)</p>
            <p className="desc">
              Many couples also use their wedding menus as an opportunity to welcome and thank their
              guests. This text is typically very short and is often found at the top or bottom of
              the card.
            </p>
          </div>
          <div className="section">
            <p className="head">4. Your Names and Wedding Date (Optional)</p>
            <p className="desc">
              To turn your wedding menu card into a scrapbook-worthy memento, include your names and
              your wedding date on the card.
            </p>
          </div>
          <div className="section">
            <p className="desc">
              Read more about how to design your wedding menu card, including helpful wording
              examples for every type of meal, in our{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/day-of-paper/a-guide-to-wedding-menu-cards"
                target="_blank"
              >
                Guide To Wedding Menu Cards.
              </Link>
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export default TipMenu;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/TipsModals/TipMenu.jsx